import { BasePayloadMapper } from '@ps/utils';

import { ReportRequestDto } from '../dtos/report-request.dto';
import { ReportRequest } from '../../models/report.model';

export class ReportPayloadMapper extends BasePayloadMapper<
  ReportRequest,
  ReportRequestDto
> {
  public toPayload(request: ReportRequest): ReportRequestDto {
    return {
      currentTimestamp: Date.now(),
      stDt: request.startDate,
      endDt: request.endDate,
      st: request.statuses,
      u: request.userId,
      c: request.companyId,
    };
  }
}
